// removed by extract-text-webpack-plugin
module.exports = {"container":"_2EUGC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Overview/style.scss
// module id = 3tVx
// module chunks = 0